import store from '@/store/index.js';
import axios from 'axios';
import firebase from 'firebase/app';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use(
  async (config) => {
    try {
      // Make sure the token is still valid and refresh if need be before using it
      const token = await firebase.auth().currentUser.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
      return config;

    } catch (err) {
      console.error('Axios Interceptor ERROR', err);
      config.headers.Authorization = null;
      return false;
    }
  },
  (error) => {
    console.log(`INTERCEPTOR ERROR - `, error);
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    store.dispatch('auth/refresh', true);
    return Promise.reject(error.response);
  },
);
